module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cta":{"select-collection":"Please select a collection"},"mode":{"inspect":"Inspect","compare":"Compare"},"sortBy":"Sort by","sortingMethods":{"HighestTotalIntersectionInPercents":"Total intercection span in %","HighestAbsoluteIntersection":"Absolute intersection"},"scale":"Scale","scales":{"linear":"Linear","sqrt":"Square root"}}}')
  delete Component.options._Ctor
}
